/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  selectAccount.tsx
*
* Project Title :  Checkout
*
* Description	:
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Avanthi G(E860178)
*
* @Date			: Aug 30, 2019
*
* @Version      : Version 1.0
*
* By            : Avanthi G (E860178)
* On            : Aug 30, 2019
* Description   : ASDS-1082:Updated code to display CheckOut routing URL in browser
*
* By            : Sandeep Raja (E807238)
* On            : Sep 23, 2019
* Description   : ASDS-1082:Updated code to display CheckOut routing URL in browser
*
* By            : H224423
* On            : Sep 27, 2019
* Description   : ASDS-1287 - Cart Popup Alignment, Font, Icon
*
* By            : E807958
* On            : Oct 31, 2019
* Description   : ASDS-1707 - Select Account Screen-ShipTo display based on SoldTo selection
*
* By            : Madhu Gali - H175591
* On            : 05 Nov 2019
* Description   : ASDS-1318
*
* By            : sivateja
* On            : Nov 8, 2019
* Description   : ASDS-167: fixed the select account logic and change account logic
*
* By            : H224423
* On            : Nov 11, 2019
* Description   : Select Account close and back redirection changes
*
* By            : H224423
* On            : Dec 3, 2019
* Description   : ASDS-1995 - UI Issue Fixes. Scroll bar issue fix for laptop.
*
* By            : Madhu Gali
* On            : Dec 18, 2019
* Description   : ASDS-584
*
* By            : Deepthi Bachu(E844276)
* On            : Jan 28, 2020
* Description   : ASDS-2048 - Admin Functionality
 *
 * By            : H224423
 * On            : Feb 06, 2020
 * Description   : ASDS-2229 - Select multiple text changes.
 *
 * By            : Deepthi Bachu - E844276
 * On            : 11 Feb, 2020
 * Description   : ASDS-2197 - Select Account - Integrate Search by Type API Integration - New Changes
 *
 * By            : H224423
 * On            : Feb 14, 2020
 * Description   : ASDS-2270 Empty account details (when address service unavailable) issue fixes.
 *
 * By            : E844276
 * On            : Feb 17, 2020
 * Description   : ASDS-954 - Verbiage Changes
 *
 * By            : E844276
 * On            : Feb 27 2020
 * Description   : Select account for admin - reset drop down box when the email/honeywell id/sold to is changed or reopened
                   Select account for admin - when the search type is changed when the search is happening - not to pre populate the address. - ASDS-2345
 *
 * By            : H224423
 * On            : Mar 2 2020
 * Description   : Updated verbiage.
 *
 * By            : Deepthi Bachu - E844276
 * On            : 04 Mar, 2020
 * Description   : ASDS-2409 - NGBSS place order service - address parameter changes
 *
 * By            : H224423
 * On            : Mar 12 2020
 * Description   : Updated verbiage.
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes.
 *
 * By            : Srinivas Grandhi (E528634)
 * On            : Apr 06,2020
 * Description   : updated code as per ASDS-2432.
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes. Changes to redirect user to default route.
 *
 * By            : H224423
 * On            : 16 Apr, 2020
 * Description   : Previous selected address not be prefilled for Admin.
 *
 * By            : H422335
 * On            : Oct 15, 2020
 * Description   : ASDS-3035 Migration of backend URLs to Forge endpoints
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 *
 * By            : H422337
 * On            : Nov, 19 2020
 * Description   : ASDS-4083 UI Enhancements for Phase-II  bug fix & Delete All  products from the cart
 *

******************************************************************************/

import * as React from 'react';
import { Select, Notification, Radio, Grid, Search, Modal, Button, Card } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './selectAccount.css';
import API from '../API/api';
import { RouteComponentProps, withRouter, Redirect } from 'react-router-dom';
import { constructUserAccountInfoObj } from '../utils/util';
import { UserAccountInformation, SaveAccountInfo, SelectAccountInfo, SaveAddressUserReqObjType } from '../utils/checkout-interfaces';
import CheckoutConstants, { CheckoutServiceURL, CheckoutUILabels } from '../constants/checkout-constants';
import { connect } from 'react-redux';
import SelectAccountActions from '../redux/actions/select-account-actions';
import CartDetailsActions from '../redux/actions/cart-details-actions';
import RouteConstants from '../constants/route-constants';
import { isValueUndefined } from '../../../utils/util';
import { InLineLoader } from '../Loader/Loader';
import { logInfo } from '../../../utils/console-utility';
import AddressDetails from '../API/select-account-api';
import RequestToAddNewAddress from '../RequestToNewAddress/requestToAddNewAddress';
import OrderHistoryActions from '../redux/actions/order-history-actions';

interface IMyComponentState {
    hasClickOut: boolean;
    results: string[];
    value: string;
    users: string[];
    isLoaded: boolean;
    loading: boolean;
    sapSoldTo: UserAccountInformation[];
    sapShipTo: UserAccountInformation[];
    selectedSAPSoldTo?: string;
    selectedSAPShipTo?: string;
    selectedSoldToAddressId?: string;
    selectedShipToAddressId?: string;
    searchIdError: string;
    soldToError: string;
    shipToError: string;
    userSFDCCaseStatus: boolean;
    customerName: string;
    accountId: string;
    prevSelectedShipTo: string;
    prevSelectedSoldTo: string;
    prevSelectedSoldToAddressId: string;
    prevSelectedShipToAddressId: string;
    isFetchingSelectAccount: boolean;
    masterSapShipTo: any;
    disablefield: boolean;
    disableRadio: boolean;
    redirectToDefaultRoute: boolean;
    showAddressPage: boolean;
}

interface ISelectAccountProps {
    sapSoldTo?: UserAccountInformation[];
    sapShipTo?: UserAccountInformation[];
    setSelectAccount: Function;
    setAdminAddresses: Function;
    deleteAllMsaProducts: Function;
    deleteAllProductsFromCart: Function;
    getOrderHistory: Function;
    open: boolean;
    onClose?: Function;
    userValidationData: any;
    adminAddressDetails: any;
    onContinue?: Function;
    selectAccountDetails: any;
    updateSearchBy: Function;
    deleteDlmuwProducts: Function;
    updatedeleteAllProductsSuccessFlag:Function;
}

/**
 * @author: H175591
 * @param props
 * @returns {any}
 * @constructor
 * @description: This component renders the content required for ShipTo and SoldTo address page.
 * @
 */
function RenderOptionsContent(props: any) {
    const userInfoObj: UserAccountInformation = props.userAccountObj;
    return (
        <div><p><b>
        {userInfoObj.customerName}</b></p><p>Honeywell Customer Code: {userInfoObj.sapNumber}</p>
        <p>{userInfoObj.addrLine1 ? userInfoObj.addrLine1 + ', ' : ''}{userInfoObj.addrLine2 ? userInfoObj.addrLine2 + ',' : ''}</p>
        <p>{userInfoObj.addrLine3 ? userInfoObj.addrLine3 + ', ' : ''}{userInfoObj.city ? userInfoObj.city + ',' : ''}</p>
        <p>{userInfoObj.state ? userInfoObj.state + ', ' : ''}{userInfoObj.country ? userInfoObj.country + ',' : ''}</p>
        <p>{userInfoObj.zip ? userInfoObj.zip + '.' : ''}</p>
        </div>
    );
}

const SelectComponent = (props: any) => {
    // Populating ShipTo options property
    let shipToOptions: any = [ {value: '',
        text: '--Select--'}];
    props.shipTos.map((ele: any) => {
        const shipToPropsObj: UserAccountInformation = ele;
        let shipTosText = '';
        shipTosText = shipTosText.concat(shipToPropsObj.customerName ? ( shipToPropsObj.customerName + '\n' ) : '' , 'Honeywell Customer Code: ' ,
                                         shipToPropsObj.sapNumber ? ( shipToPropsObj.sapNumber + '\n' ) : '' , shipToPropsObj.addrLine1 ? ( shipToPropsObj.addrLine1 + '\n' ) : '' ,
                                         shipToPropsObj.addrLine2 ? ( shipToPropsObj.addrLine2 + '\n' ) : '' , shipToPropsObj.addrLine3 ? ( shipToPropsObj.addrLine3 + '\n' ) : '' ,
                                         shipToPropsObj.country ? ( shipToPropsObj.country + '\n' ) : '' , shipToPropsObj.stateCode ? shipToPropsObj.stateCode : '');
        if ( shipToPropsObj.customerName && shipToPropsObj.sapNumber ) {
            shipToOptions.push({
                value: shipToPropsObj.addressId,
                text: shipTosText,
                content: () => <RenderOptionsContent userAccountObj={shipToPropsObj} />
            });
        }
    });
    logInfo('shipToOptions ', shipToOptions);

    // Populating SoldTo options property
    let soldToOptions: any = [{value: '',
    text: '--Select--'}];
    props.soldTos.map((ele: any) => {
        const shipToPropsObj: UserAccountInformation = ele;
        let soldTosText = '';
        soldTosText = soldTosText.concat(shipToPropsObj.customerName ? ( shipToPropsObj.customerName + '\n' ) : '' , 'Honeywell Customer Code: ',
                                         shipToPropsObj.sapNumber ? ( shipToPropsObj.sapNumber + '\n' ) : '', shipToPropsObj.addrLine1 ? ( shipToPropsObj.addrLine1 + '\n' ) : '',
                                         shipToPropsObj.addrLine2 ? ( shipToPropsObj.addrLine2 + '\n' ) : '', shipToPropsObj.addrLine3 ? ( shipToPropsObj.addrLine3 + '\n' ) : '',
                                         shipToPropsObj.country ? ( shipToPropsObj.country + '\n' ) : '', shipToPropsObj.stateCode ? shipToPropsObj.stateCode : '');
        if ( shipToPropsObj.customerName && shipToPropsObj.sapNumber ) {
        soldToOptions.push({
            value: shipToPropsObj.addressId,
            text: soldTosText,
            content: () => <RenderOptionsContent userAccountObj={shipToPropsObj} />
        });
    }
    });

    logInfo('soldToOptions ', soldToOptions);

    return (
        <React.Fragment>
            <div>
                <Select
                    value={props.prevSelectedSoldToAddressId || ''}
                    label="Select Billing Address"
                    placeholder="Select Billing Address"
                    indicator="required"
                    error={props.soldToError}
                    options={soldToOptions}
                    onChange={(value) => {
                        props.triggerSoldToUpdate(value);
                    }}
                    className="sa-billing-addr-dropdown"
                />
            </div>
            <div>
                <Select
                    value={props.prevSelectedShipToAddressId}
                    label="Select Shipping Address"
                    placeholder="Select Shipping Address"
                    indicator="required"
                    error={props.shipToError}
                    options={shipToOptions}
                    onChange={(value) => (props.triggerShipToUpdate(value))}
                    className="sa-shipping-addr-dropdown"
                />
            </div>
        </React.Fragment>
    );
};

class SelectAccount extends React.PureComponent<ISelectAccountProps & RouteComponentProps, IMyComponentState> {
    getUsersRequest: NodeJS.Timeout;
    constructor(props: ISelectAccountProps & RouteComponentProps) {
        super(props);
        this.state = {
            showAddressPage: false,
            isLoaded: false,
            hasClickOut: false,
            results: [],
            value: '',
            users: [],
            sapSoldTo: [],
            sapShipTo: [],
            loading: false,
            selectedSAPSoldTo: '',
            selectedSAPShipTo: '',
            selectedSoldToAddressId: '',
            selectedShipToAddressId: '',
            searchIdError: '',
            soldToError: '',
            shipToError: '',
            userSFDCCaseStatus: false,
            customerName: '',
            accountId: '',
            prevSelectedShipTo: '',
            prevSelectedSoldTo: '',
            prevSelectedSoldToAddressId: '',
            prevSelectedShipToAddressId: '',
            isFetchingSelectAccount: false,
            masterSapShipTo: [],
            disablefield:false,
            disableRadio:false,
            redirectToDefaultRoute: false
        };
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSearchClear = this.handleSearchClear.bind(this);
        this.handleSearchSelect = this.handleSearchSelect.bind(this);
        this.handleChangeEvent = this.handleChangeEvent.bind(this);
        this.redirectToProductsListing = this.redirectToProductsListing.bind(this);
        this.populateStateWithSoldToValue = this.populateStateWithSoldToValue.bind(this);
        this.populateStateWithShipToValue = this.populateStateWithShipToValue.bind(this);
        this.filterShipToBasedOnSelectedSoldTo = this.filterShipToBasedOnSelectedSoldTo.bind(this);
        this.setRedirectUser = this.setRedirectUser.bind(this);
    }

    handleChangeEvent = (searchBy) => {
        // Re-setting results at each change in search
        this.setState({
            value: '',
            results: [],
            selectedSAPSoldTo: '',
            selectedSAPShipTo: '',
            selectedSoldToAddressId: '',
            selectedShipToAddressId: '',
            sapSoldTo: [],
            sapShipTo: [],
            searchIdError: ''
        });

        this.props.updateSearchBy(searchBy);
    }

    // filtering shipto's based on selected soldto value
    filterShipToBasedOnSelectedSoldTo(addressId: any) {
        let selectedSapNumber;
        const selectedSoldToAccountId = this.state.sapSoldTo.filter(eachShipTo => {
            return eachShipTo.addressId === addressId;
        });
        const filteredShipTo: UserAccountInformation[] = [];
        this.state.masterSapShipTo.filter(eachShipTo => {
            if (eachShipTo.accountId === selectedSoldToAccountId[0].accountId) {
                selectedSapNumber = selectedSoldToAccountId[0].sapNumber;
                filteredShipTo.push(eachShipTo);
            }
        });
        this.setState({
            sapShipTo: filteredShipTo,
            soldToError: ''             // resetting sold to Error Msg
        });
        logInfo('this.state ', this.state);
        return selectedSapNumber;
    }

    populateStateWithSoldToValue(addressId) {
        const sapSoldTo = this.filterShipToBasedOnSelectedSoldTo(addressId);

        this.setState(() => ({
            selectedSAPSoldTo: sapSoldTo,
            selectedSoldToAddressId: addressId,
            soldToError: ''             // resetting sold to Error Msg
        }));

        logInfo('this.state ', this.state);
    }

    async populateStateWithShipToValue(addressId) {

        let sapShipTo = this.state.sapShipTo.find(eachShipTo => eachShipTo.addressId = addressId)?.sapNumber


        this.setState({
            selectedSAPShipTo: sapShipTo,
            selectedShipToAddressId: addressId,
            shipToError: ''             // resetting ship to Error Msg
        });
        logInfo('this.state ', this.state);
    }

    handleSearchChange(value: any) {
        // Re-setting results at each change in search
        this.setState({
            value: value,
            results: [],
            selectedSAPSoldTo: '',
            selectedSAPShipTo: '',
            selectedSoldToAddressId: '',
            selectedShipToAddressId: '',
            sapSoldTo: [],
            sapShipTo: [],
            searchIdError: ''
        });
        if (value.length >= 3) {
            this.setState({
                loading: true,
                disableRadio: true,
            },            () => {
                if (this.getUsersRequest) {
                    clearTimeout(this.getUsersRequest)
                }
                this.getUsersRequest = setTimeout(() => this.getuserIds(value).then(() => {
                    this.setState({disableRadio: false});
                }), CheckoutConstants.IDLE_TIME_FOR_SEARCH_REQUEST);
            });
        }
    }
    /**
     * Callback for Search input - onResultClear
     */
    handleSearchClear() {
        // Re-setting results at each change in search
        this.setState({
            value: '',
            results: [],
            selectedSAPSoldTo: '',
            selectedSAPShipTo: '',
            selectedSoldToAddressId: '',
            selectedShipToAddressId: '',
            sapSoldTo: [],
            sapShipTo: [],
            searchIdError: '',
            disablefield: false,
            disableRadio: false,
        });
    }

    handleSearchSelect(result: any) {
        this.setState({
            value: result.title,
            selectedSAPSoldTo: '',
            selectedSAPShipTo: '',
            selectedSoldToAddressId: '',
            selectedShipToAddressId: '',
            soldToError: '',
            shipToError: '',
            sapSoldTo: [],
            sapShipTo: [],
            searchIdError: '',
            disablefield: true,
            disableRadio: true,
        });
        this.setState({
            isFetchingSelectAccount: true,
        },            () => {
            this.props.setAdminAddresses(result.title, this.props.selectAccountDetails.searchBy).then(() => {
                this.setState({
                    isFetchingSelectAccount: false,
                    disablefield: false,
                    disableRadio: false,
                },            () => {
                    this.getSelectAccountDetails();
                });
            });
        });
    }

    componentDidMount() {
        if (this.props.userValidationData.payload.userAddrDetails && this.props.userValidationData.payload.userAddrDetails.results) {
            const isAdmin = this.props.userValidationData.payload.isAdminUser;
            if (!isAdmin) {
                this.getSelectAccountDetails();
            }
        }
    }

    async handleClose() {
        this.props.onContinue && this.props.onContinue();
        !this.props.onContinue && this.props.history.push(RouteConstants.PURCHASE_SOFTWARE);
    }

    setRedirectUser () {
        this.setState({
            redirectToDefaultRoute: true
        });
    }

    render() {
        if (this.state.showAddressPage) {
            return <RequestToAddNewAddress/>;
        }
        if (this.state.redirectToDefaultRoute) {
            return <Redirect to={RouteConstants.DEFAULT_ROUTE} />;
        } else {
            return (
                <React.Fragment>
                    {this.renderModal()}
                </React.Fragment>
            );
        }
    }

    renderModal() {
        const values: any = [];
        if (this.state.results) {
            this.state.results.forEach((value: any, index) =>
                values.push({ title: value, key: index})
            );
        }

        return (
            <Modal
                closeIcon={true}
                onClose={() => { this.props.onClose && this.props.onClose(); }}
                size="small"
                open={this.props.open}
                closeOnDimmerClick={this.state.hasClickOut}
                closeOnDocumentClick={this.state.hasClickOut}
                className="selectAccountModal select-user-account-modal"
            >
                <Modal.Header className="sa-header">
                    Select Account
                </Modal.Header>
                <div className="box">
                    {!this.props.userValidationData.payload.userAddrDetails &&
                    <Notification
                        severity="critical"
                        hasIcon={true}
                        title="There is an error in processing your request."
                        detailsText="Retry"
                        onDetailsClick={() => this.setRedirectUser()}
                    />}
                    {this.props.userValidationData.payload.userAddrDetails && <Modal.Content>
                    <Card className="sa-account-details-card">
                        <Card.Content>
                             {/* {(this.props.userValidationData.payload.userAddrDetails.results && this.props.userValidationData.payload.userAddrDetails.results.isAdmin */}
                                 {(this.props.userValidationData.payload.userAddrDetails.results && this.props.userValidationData.payload.isAdminUser
                                    ? <div>
                                        <div>
                                            <p>Search by:</p>
                                            <Grid width={12} className="selectacc-grid">
                                                <Grid.Row width={12} className="selectacc-grid">
                                                    <Grid.Column width={5} className="selectacc-grid-col">
                                                        <Radio
                                                            disabled={this.state.disableRadio}
                                                            label="Honeywell ID"
                                                            className="selectacc-grid-radio"
                                                            name="RadioGroup"
                                                            onChange={() => this.handleChangeEvent(CheckoutConstants.SELECT_ACCOUNT_SEARCH_BY_HONID)}
                                                            checked={this.props.selectAccountDetails.searchBy === CheckoutConstants.SELECT_ACCOUNT_SEARCH_BY_HONID}
                                                        />
                                                    </Grid.Column>
                                                    <Grid.Column width={4} className="selectacc-grid-col">
                                                        <Radio
                                                            disabled={this.state.disableRadio}
                                                            label="Email ID"
                                                            className="selectacc-grid-radio"
                                                            name="RadioGroup"
                                                            onChange={() => this.handleChangeEvent(CheckoutConstants.SELECT_ACCOUNT_SEARCH_BY_EMAILID)}
                                                            checked={this.props.selectAccountDetails.searchBy === CheckoutConstants.SELECT_ACCOUNT_SEARCH_BY_EMAILID}
                                                        />
                                                    </Grid.Column>
                                                    <Grid.Column width={3} className="selectacc-grid-col">
                                                        <Radio
                                                            disabled={this.state.disableRadio}
                                                            label="Sold To"
                                                            className="selectacc-grid-radio"
                                                            name="RadioGroup"
                                                            onChange={() => this.handleChangeEvent(CheckoutConstants.SELECT_ACCOUNT_SEARCH_BY_SOLDTO)}
                                                            checked={this.props.selectAccountDetails.searchBy === CheckoutConstants.SELECT_ACCOUNT_SEARCH_BY_SOLDTO}
                                                        />
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                        </div>

                                        <Search
                                            placeholder="Please start typing..."
                                            disabled={this.state.disablefield}
                                            loading={this.state.loading}
                                            minCharacters={3}
                                            results={values}
                                            value={this.state.value}
                                            onResultSelect={this.handleSearchSelect}
                                            onSearchChange={this.handleSearchChange}
                                            onResultClear={this.handleSearchClear}
                                            error={this.state.searchIdError}
                                            noResultsMessage={this.state.loading ? 'Please Wait...' : 'No Results Found.'}
                                            className="sa-user-search"
                                        />
                                    </div>
                                    : null)}
                            {this.state.isFetchingSelectAccount && <InLineLoader loading={true} text="Fetching Customer Details" overlayColor="transparent"><h1></h1></InLineLoader>}
                            {!this.state.isFetchingSelectAccount &&
                                <div>
                                    <SelectComponent
                                        soldToError={this.state.soldToError}
                                        shipToError={this.state.shipToError}
                                        soldTos={this.state.sapSoldTo}
                                        shipTos={this.state.sapShipTo}
                                        triggerSoldToUpdate={this.populateStateWithSoldToValue}
                                        triggerShipToUpdate={this.populateStateWithShipToValue}
                                        // prevSelectedSoldToAddressId={this.props.userValidationData.payload.userAddrDetails.results && this.props.userValidationData.payload.userAddrDetails.results.isAdmin ? this.state.selectedSoldToAddressId : this.state.selectedSoldToAddressId || this.state.prevSelectedSoldToAddressId}
                                        prevSelectedSoldToAddressId={this.props.userValidationData.payload.userAddrDetails.results && this.props.userValidationData.payload.isAdminUser ? this.state.selectedSoldToAddressId : this.state.selectedSoldToAddressId || this.state.prevSelectedSoldToAddressId}
                                        // prevSelectedShipToAddressId={this.props.userValidationData.payload.userAddrDetails.results && this.props.userValidationData.payload.userAddrDetails.results.isAdmin ? this.state.selectedShipToAddressId : this.state.selectedShipToAddressId || this.state.prevSelectedShipToAddressId}
                                        prevSelectedShipToAddressId={this.props.userValidationData.payload.userAddrDetails.results && this.props.userValidationData.payload.isAdminUser ? this.state.selectedShipToAddressId : this.state.selectedShipToAddressId || this.state.prevSelectedShipToAddressId}
                                    />
                                </div>
                            }
                        </Card.Content>
                    </Card>
                    <Card className="sa-add-new-addr-card">
                        <Card.Content>If you require a new address to be listed {' '}
                            <Button
                                type="link"
                                data-testid="clickHere"
                                content="Add New Address"
                                onClick={() => this.redirectToNewAddess()}
                            />
                        </Card.Content>
                    </Card>
                        </Modal.Content> }
                </div>
                {this.props.userValidationData.payload.userAddrDetails && <Modal.Footer>
                    <div>
                        <Button
                            type="secondary"
                            size="small"
                            content="Cancel"
                            onClick={() => { this.props.onClose && this.props.onClose(); }}
                        />
                        <Button
                            type="primary"
                            size="small"
                            content="Continue"
                            data-testid="continue"
                            onClick={this.redirectToProductsListing}
                        />
                    </div>
                </Modal.Footer>}
            </Modal>
        );
    }

    private async getuserIds(searchTerm) {
        try {
            const searchBy = this.props.selectAccountDetails.searchBy;
            let response;
            if (CheckoutConstants.SELECT_ACCOUNT_SEARCH_BY_SOLDTO === searchBy) {
                const URL: string = `${CheckoutServiceURL.ADMIN_ADDRESS_DETAILS_URL}`;
                response = await API.get(URL, { params: {'searchField': searchBy , 'searchType': 'wildcard', 'search': searchTerm}});
            }
            else {
                response = await API.get(
                    CheckoutServiceURL.GET_CONTACT_DETAILS_URL,
                    { params: {'searchField': searchBy, 'search': searchTerm } }
                );
            }

            let getHonIds: any = [];
            const accountSoldTos: any = [];
            switch (searchBy) {
                case CheckoutConstants.SELECT_ACCOUNT_SEARCH_BY_EMAILID:
                        response.data.contacts.map((value: any) =>
                            getHonIds.push(value.emailId)
                        );
                        break;
                case CheckoutConstants.SELECT_ACCOUNT_SEARCH_BY_SOLDTO:
                        response.data.accounts.map((account: any) =>
                            account.sapSoldTo && account.sapSoldTo.map(accSoldTo =>
                                accSoldTo.sapNumber && accountSoldTos.push(accSoldTo.sapNumber)
                            )
                        );

                        getHonIds = accountSoldTos.filter((elem, pos) =>
                            accountSoldTos.indexOf(elem) === pos
                        );
                        break;
                default:
                        response.data.contacts.map((value: any) =>
                            getHonIds.push(value.userId)
                    );
            }
            this.setState({
                results: getHonIds,
            });
        } catch (error) {
            this.setState({
                searchIdError: CheckoutUILabels.STANDARD_ERROR_MESSAGE + ' ' + CheckoutUILabels.PLEASE_TRY_AGAIN,
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    }

    private getSelectAccountDetails() {
        const isAdmin = this.props.userValidationData.payload.isAdminUser;
        let addressDetails: any = [];
        if (isAdmin) {
            if ( !this.props.adminAddressDetails.isFetching && !this.props.adminAddressDetails.isSuccess ) {
                this.setState({
                    searchIdError: CheckoutUILabels.STANDARD_ERROR_MESSAGE + ' ' + CheckoutUILabels.PLEASE_TRY_AGAIN ,
                });
            }
            addressDetails = this.props.adminAddressDetails.data ? this.props.adminAddressDetails.data.results : {};
        } else {
            addressDetails = this.props.userValidationData.payload.userAddrDetails.results;
        }
        logInfo('User addressDetails inside selectAccount', addressDetails);
        const sapSoldTo: any = [];
        const sapShipTo: any = [];
        let customerName: string = '';
        let accountId: string = '';
        const filteredShipTo: UserAccountInformation[] = [];
        if (!isValueUndefined(addressDetails.account) && addressDetails.account.accounts) {
            addressDetails.account.accounts.forEach((account: any) => {

                customerName = account.customerName;
                accountId = account.accountId;

                // Populating SoldTo array
                if (account.sapSoldTo) {
                    account.sapSoldTo.forEach((e: UserAccountInformation) => {
                        const sapSoldToObj: UserAccountInformation = constructUserAccountInfoObj(e);
                        sapSoldToObj.customerName = customerName;
                        sapSoldToObj.accountId = accountId;
                        sapSoldTo.push(sapSoldToObj);
                    });
                }

                // Populating ShipTo array
                if (account.sapShipTo) {
                    account.sapShipTo.forEach((eachSapShipTo: UserAccountInformation) => {
                        const sapShipToObj: UserAccountInformation = constructUserAccountInfoObj(eachSapShipTo);
                        sapShipToObj.customerName = customerName;
                        sapShipToObj.accountId = accountId;
                        sapShipTo.push(sapShipToObj);
                    });
                }
            });
            this.setState({
                masterSapShipTo: sapShipTo
            });

            let prevSelectedAddress = { shipTo: '', soldTo: '', shipToId: '', soldToId: '' };

            /*populating previously selected account details*/
            let { shipTo: shipToObj, soldTo: soldToObj } = this.props.selectAccountDetails.payload;

            if (shipToObj && soldToObj && shipToObj.sapNumber && soldToObj.sapNumber) {
                // populating previus slected value from data store.
                prevSelectedAddress.shipTo = shipToObj.sapNumber;
                prevSelectedAddress.soldTo = soldToObj.sapNumber;
                prevSelectedAddress.shipToId = shipToObj.addressId;
                prevSelectedAddress.soldToId = soldToObj.addressId;

            } else {
                // populating previus slected value from data from db.
                prevSelectedAddress = this.props.userValidationData.payload.userAddrDetails.results.prevSelectedAddress;
            }
            if (prevSelectedAddress && prevSelectedAddress.shipTo && prevSelectedAddress.soldTo) {

                const selectedSoldToAccountId = sapSoldTo.filter(eachShipTo => {
                    return eachShipTo.addressId === prevSelectedAddress.soldToId;
                });

                if (selectedSoldToAccountId.length) {
                    sapShipTo.filter(eachShipTo => {
                        if (eachShipTo.accountId === selectedSoldToAccountId[0].accountId) {
                            filteredShipTo.push(eachShipTo);
                        }
                    });
                }
                else {
                    // Need to handle this scenario - Old address deleted
                }
                if (!isAdmin) {
                    this.setState({
                        prevSelectedShipTo: prevSelectedAddress.shipTo,
                        prevSelectedSoldTo: prevSelectedAddress.soldTo,
                        prevSelectedShipToAddressId: prevSelectedAddress.shipToId,
                        prevSelectedSoldToAddressId: prevSelectedAddress.soldToId,
                        selectedSAPSoldTo: prevSelectedAddress.soldTo,
                        selectedSAPShipTo: prevSelectedAddress.shipTo,
                        selectedShipToAddressId: prevSelectedAddress.shipToId,
                        selectedSoldToAddressId: prevSelectedAddress.soldToId
                    });
                } else {
                    this.setState({
                        prevSelectedShipTo: prevSelectedAddress.shipTo,
                        prevSelectedSoldTo: prevSelectedAddress.soldTo,
                        prevSelectedShipToAddressId: prevSelectedAddress.shipToId,
                        prevSelectedSoldToAddressId: prevSelectedAddress.soldToId,
                    });
                }
            }
        }

        this.setState({
            isLoaded: true,
            sapSoldTo: sapSoldTo,
            sapShipTo: filteredShipTo,
            customerName, accountId,
            soldToError: ''
        });
    }

    private redirectToNewAddess() {
        this.setState({
            showAddressPage: true
        });
    }

    /* Redirects to Products listing page on click of CONTINUE button */
    private redirectToProductsListing() {
        const isAdmin = this.props.userValidationData.payload.isAdminUser;

        const searchIdErrorMsg = 'Please enter Honeywell ID or SoldTo Number or Email Address';
        const soldToErrorMsg = 'Please choose Billing Address';
        const shipToErrorMsg = 'Please choose Shipping Address';

        if (this.state.selectedSAPSoldTo && this.state.selectedSAPShipTo && this.state.sapSoldTo.length > 0) {
            const selectedSoldTo = this.state.sapSoldTo.filter(eachSoldTo => {
                return eachSoldTo.addressId === this.state.selectedSoldToAddressId;
            });
            const selectedShipTo = this.state.sapShipTo.filter(eachShipTo => {
                return eachShipTo.addressId === this.state.selectedShipToAddressId;
            });
            const selectAccount: SelectAccountInfo = {
                customerName: selectedSoldTo.length === 0 ? this.state.sapSoldTo[0].customerName
                    : selectedSoldTo[0].customerName,
                customerId: this.state.value,
                accountId: selectedSoldTo.length === 0 ? this.state.sapSoldTo[0].accountId
                : selectedSoldTo[0].accountId,
                shipTo: selectedShipTo[0],
                soldTo: selectedSoldTo[0],
            };

            if (isAdmin) {
                if (this.state.value) {
                    this.setState({
                        searchIdError: '',
                        soldToError: '',
                        shipToError: '',
                    },            () => {
                        let user = this.props.userValidationData.payload.userInfo;
                        const userObj: SaveAccountInfo = {
                            userId: user.customer_sub,
                            sapSoldTo: selectAccount.soldTo.sapNumber,
                            sapShipTo: selectAccount.shipTo.sapNumber,
                            soldToAddressId: selectAccount.soldTo.addressId,
                            shipToAddressId: selectAccount.shipTo.addressId,
                        };
                        this.props.setSelectAccount(selectAccount, userObj);
                        this.handleClose();

                        // delete all cart products for a given user if admin user changes sold to address.
                        // delete products if the previous sold to is undefined

                    });
                }
            } // End of isAdmin if
            else {
                this.setState({
                    searchIdError: '',
                    soldToError: '',
                    shipToError: '',
                },            () => {
                    let user = this.props.userValidationData.payload.userInfo;

                    const userObj: SaveAccountInfo = {
                        userId: user.customer_sub,
                        sapSoldTo: selectAccount.soldTo.sapNumber,
                        sapShipTo: selectAccount.shipTo.sapNumber,
                        soldToAddressId: selectAccount.soldTo.addressId,
                        shipToAddressId: selectAccount.shipTo.addressId,
                    };

                    this.props.setSelectAccount(selectAccount, userObj);

                    const saveAddressUserRequestObj: SaveAddressUserReqObjType = {
                        defaultAddresses: []
                    };

                    saveAddressUserRequestObj.defaultAddresses.push(userObj);
                    AddressDetails.saveSelectedAddressDetails(user.customer_sub, saveAddressUserRequestObj);
                    this.handleClose();
                });
            }   // End of isAdmin else block

            // delete MSA products if any
            // if (this.state.prevSelectedSoldTo && this.state.prevSelectedSoldTo !== this.state.selectedSAPSoldTo) {
            //     this.props.deleteAllMsaProducts(selectAccount.soldTo.sapNumber);
            //     this.props.deleteDlmuwProducts();
            //     this.props.updatedeleteAllProductsSuccessFlag(false);
            // }
            if ( this.state.prevSelectedSoldTo && this.state.prevSelectedSoldTo !== this.state.selectedSAPSoldTo) {
                this.props.deleteAllProductsFromCart();
                this.props.updatedeleteAllProductsSuccessFlag(false);
            }

            if (this.props.location.pathname === RouteConstants.ORDER_HISTORY) {
                let soldTos = this.state.sapSoldTo.map(soldTo => soldTo.sapNumber);
                let soldToObj = soldTos.join(',');
                this.props.getOrderHistory(soldToObj);
            }
        }
        else {
            if (!this.state.value) {
                this.setState(
                    {searchIdError: searchIdErrorMsg},
                    () => logInfo('this.state.errorMsg[\'honeywellId\'])', this.state.searchIdError)
                    );
            }
            if (!this.state.selectedSAPSoldTo) {
                this.setState({
                    soldToError: soldToErrorMsg
                });
            }
            if (!this.state.selectedSAPShipTo) {
                this.setState({
                    shipToError: shipToErrorMsg
                });
            }
        }
    }
}

function mapStateToProps(state) {
    return {
        userValidationData: state.userValidationData,
        adminAddressDetails: state.selectAccount.adminAddressDetails,
        selectAccountDetails: state.selectAccount.selectAccountDetails
    };
}

const mapDispatchToProps = {
    setSelectAccount: SelectAccountActions.setSelectAccount,
    setAdminAddresses: SelectAccountActions.setAdminAddressDetails,
    deleteAllMsaProducts: CartDetailsActions.deleteAllMsaProducts,
    deleteAllProductsFromCart: CartDetailsActions.deleteAllProductsFromCart,
    updateSearchBy: SelectAccountActions.updateSearchBy,
    deleteDlmuwProducts: CartDetailsActions.deleteDlmuwProducts,
    getOrderHistory: OrderHistoryActions.getOrderHistory,
    updatedeleteAllProductsSuccessFlag: CartDetailsActions.updatedeleteAllProductsSuccessFlag
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectAccount));